<template>
<div class="containers">
    <div class="search-area">
        <CRow class="no-gutters">
            <CCol style="padding-right:4px" sm="3">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisiblePegawai()"
                            @blur="toggleCloseVisiblePegawai()"
                            v-model="queryPegawai"
                            v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                            @keydown.up="upPegawai"
                            @keydown.down="downPegawai"
                            @keydown.enter="selectItemPegawai"
                            placeholder="Pilih Pegawai"
                    >
                    <div class="popovers" v-show="visiblePegawai">
                        <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesPegawai"
                                :key="index"
                                :class="{ 'selected': (selectedPegawai == index)}"
                                @click="itemClickedPegawai(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="3">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisibleUnit()"
                            @blur="toggleCloseVisibleUnit()"
                            v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                            v-model="queryUnit"
                            @keydown.up="upUnit"
                            @keydown.down="downUnit"
                            @keydown.enter="selectItemUnit"
                            placeholder="Pilih Unit Level"
                    >
                    <div class="popovers" v-show="visibleUnit">
                        <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesUnit"
                                :key="index"
                                :class="{ 'selected': (selectedUnit == index)}"
                                @click="itemClickedUnit(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                            Data Tidak Ditemukan
                        </div>
                        <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                            Start Typing...
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <div class="autocomplete">
                    <input type="text"
                            class="form-control"
                            @click="toggleVisibleTipePegawai()"
                            @blur="toggleCloseVisibleTipePegawai()"
                            v-model="queryTipePegawai"
                            v-text="selectedItemTipePegawai ? selectedItemTipePegawai['text'] : ''"
                            @keydown.up="upTipePegawai"
                            @keydown.down="downTipePegawai"
                            @keydown.enter="selectItemTipePegawai"
                            placeholder="Pilih Tipe Pegawai"
                    >
                    <div class="popovers" v-show="visibleTipePegawai">
                        <div class="options" v-if="matchesTipePegawai.length != 0 && queryTipePegawai.length != 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in matchesTipePegawai"
                                :key="index"
                                :class="{ 'selected': (selectedTipePegawai == index)}"
                                @click="itemClickedTipePegawai(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesTipePegawai.length == 0 && queryTipePegawai.length == 0" ref="optionsList">
                            <ul>
                            <li v-for="(match, index) in dataTipePegawai"
                                :key="index"
                                :class="{ 'selected': (selectedKota == index)}"
                                @click="itemClickedTipePegawaiBefore(index)"
                                v-text="match['text']"></li>
                            </ul>
                        </div>
                        <div class="options" v-if="matchesTipePegawai.length == 0 && queryTipePegawai.length != 0">
                            Data Tidak Ditemukan
                        </div>
                    </div>
                </div>
            </CCol>
            <CCol style="padding-right:4px;padding-left:4px" sm="2">
                <month-picker-input placeholder="Bulan" :no-default="true" :show-year="true" :default-year="date.year" @change="showDate"></month-picker-input>
            </CCol>
            <CCol style="padding-left:6px" sm="2">
                <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
            </CCol>
        </CRow>
    </div>
    <div class="sticky1">
        <CRow>
            <CCol sm="6" style="float:left">
                <img class="mr-4 mt-1" @click="reload()" title="refresh" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="cursor:pointer;float:left"/>
                <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:left;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                <img class="mr-4 mt-1" style="float:left" :src="moreIcon" width="20px" height="20px"/>
            </CCol>
            <CCol sm="6">
                <span style="float:right">
                    <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                    <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                </span>
                <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
            </CCol>
        </CRow>
    </div>
    <div class="row" style="padding-left:24px">
        <div class="col-12">
            <span style="color:rgba(154, 154, 154, 1);font-size:12px">Keterangan :</span>
        </div>
        <div class="col-12">
            <span style="color:rgba(154, 154, 154, 1);font-size:12px"><span class="font-weight-bold">HKS</span> = Hari Kerja Seharusnya, <span class="font-weight-bold">HKP</span> = Hari Kerja Pegawai, <span class="font-weight-bold">JKS</span> = Jam Kerja Seharusnya (Jam), <span class="font-weight-bold">JKP</span> = Jam Kerja Pegawai (Jam), <span class="font-weight-bold">NSI</span> = Tidak Absen Masuk, <span class="font-weight-bold">NSO</span> = Tidak Absen Pulang, <span class="font-weight-bold">LEAVE</span> = Total Leave Request, <span class="font-weight-bold">MANGKIR(1TH)</span> = Total Mangkir (1 Tahun).</span>
        </div>
    </div>
    <Tables @sort="sorting" @detail="getDetail" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    <Dialogs ref="dialog" @download="getDownloadDetail" @downloadMangkir="getDownloadMangkir"/>
</div>
</template>

<script>
import Tables from '../component/tableAbsensi'
import {DataApi} from "../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { MonthPickerInput } from 'vue-month-picker'
import Dialogs from '../component/DialogAbsensi'

const xlsx = require('json-as-xlsx')

export default {
    components: {
        ModelSelect,
        Tables,
        MonthPickerInput,
        Dialogs
    },
    data() {
        return {
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,

            // data search unit
            dataUnit: [],
            titleUnit:"Pilih Unit Level",
            selectedItemUnit: null,
            selectedUnit: 0,
            queryUnit: '',
            visibleUnit: false,
            idUnits: '',

            // data search Tipe Pegawai
            dataTipePegawai: [],
            titleTipePegawai:"Pilih Tipe Pegawai",
            selectedItemTipePegawai: null,
            selectedTipePegawai: 0,
            queryTipePegawai: '',
            visibleTipePegawai: false,
            kodeTipePegawai: '',

            // datas
            refreshIcon: require('../assets/menu/icon_refresh.svg'),
            downloadIcon: require('../assets/menu/icon_download_excel.svg'),
            moreIcon: require('../assets/menu/icon_more.svg'),
            dataTh: ['Nama / NIP', 'HKS', 'HKP', 'JKS', 'JKP', 'WFH', 'WFO', 'WFA', 'SPPD', 'LEAVE', 'TRAINING', 'MANGKIR', 'NSI', 'NSO', 'TELAT', 'MANGKIR(1TH)'],
            dataTd: [['nama', 'nik'], 'hariKerjaKalender', 'hariKerjaPegawai', 'jks', 'jkp', 'wfh', 'wfo', 'wfa', 'dinas', 'leaveRequest', 'training', 'mangkir', 'nsi', 'nso', 'telat', 'acuanCuti'],
            styleTable: ['60px', '25px', '25px', '25px', '25px', '25px', '25px', '25px', '25px', '25px', '30px', '30px', '25px', '25px', '30px', '30px' ],
            classReload: 'reloadOff',
            datas: [],
            dataBulan: [],
            datasTemporary: [],

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchValue: '',
            date: {
                from: null,
                to: null,
                month: null,
                monthIndex: null,
                year: null
            },
            tanggal: new Date(),

            // error
            errorMessage: '',
            flagSearch: false
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
        matchesUnit() {
            if (this.queryUnit == '') {
                return [];
            }
            return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
        },
        matchesTipePegawai() {
            if (this.queryTipePegawai == '') {
                return [];
            }
            return this.dataTipePegawai.filter((item) => item['text'].toLowerCase().includes(this.queryTipePegawai.toLowerCase()))
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchValue() {
            this.flagSearch = true
        },
        queryPegawai() {
            this.flagSearch = true
            this.getDataPegawai()
        },
        queryUnit() {
            this.flagSearch = true
            this.getDataUnit()
        },
        queryTipePegawai() {
            this.flagSearch = true
            if(this.queryTipePegawai == '') {
                this.kodeTipePegawai = ''
            }
            this.getDataTipePegawai()
        },
        date() {
            this.flagSearch = true
        }
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].nik,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },
        //

        /**
         * SEARCH UNIT LEVEL
         */
        getDataUnit() {
            let payload = {
                limit: 10,
                namaUnit: this.queryUnit,
                pageIn: 1,
                namaParentUnit: '',
                idUnit: ''
            }
            DataApi.post("unit/get", payload)
            .then(res => {
                this.dataUnit = []
                let response = res.data.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = ''
                    if(tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang
                        }                      
                    } else {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang + ' - ' + tempData[i].parentBidang                            
                        }
                    }
                    this.dataUnit.push(onPush)
                }
            })
        },
        toggleVisibleUnit() {
            this.visibleUnit = true;
        },
        hideUnit() {
            this.visibleUnit = false;
        },
        toggleCloseVisibleUnit() {
            setTimeout(this.hideUnit, 1000);
        },
        itemClickedUnit(index) {
            this.selectedUnit = index;
            this.selectItemUnit();
        },
        selectItemUnit() {
            if (!this.matchesUnit.length) {
            return;
            }
            this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
            this.queryUnit = this.selectedItemUnit.text
            this.idUnits = this.selectedItemUnit.value
            this.visibleUnit = false;
            if (this.shouldReset) {
            this.queryUnit = '';
            this.selectedUnit = 0;
            }
        },
        upUnit() {
            if (this.selectedUnit == 0) {
            return;
            }
            this.selectedUnit -= 1;
            this.scrollToItemUnit();
        },
        downUnit() {
            if (this.selectedUnit >= this.matchesUnit.length - 1) {
            return;
            }
            this.selectedUnit += 1;
            this.scrollToItemUnit();
        },
        scrollToItemUnit() {
            this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
        },

        /**
         * SEARCH TIPE PEGAWAI
         */
        getDataTipePegawai() {
            this.dataTipePegawai = []
            let payload = {
                keterangan: this.queryTipePegawai,
                limit: 10,
                pageIn: 1
            }
            DataApi.post("pegawai/status/lihat", payload)
            .then(res => {
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].kode,
                        text: tempData[i].keterangan
                    }
                    this.dataTipePegawai.push(onPush)
                }
            })
        },
        toggleVisibleTipePegawai() {
            this.visibleTipePegawai = true;
        },
        hideTipePegawai() {
            this.visibleTipePegawai = false;
        },
        toggleCloseVisibleTipePegawai() {
            setTimeout(this.hideTipePegawai, 1000);
        },
        itemClickedTipePegawai(index) {
            this.selectedTipePegawai = index;
            this.selectItemTipePegawai();
        },
        itemClickedTipePegawaiBefore(index) {
            this.selectedTipePegawai = index;
            this.selectedItemTipePegawai = this.dataTipePegawai[this.selectedTipePegawai];
            this.kodeTipePegawai = this.selectedItemTipePegawai.value
            this.queryTipePegawai = this.selectedItemTipePegawai.text
            this.visibleTipePegawai = false;
        },
        selectItemTipePegawai() {
            if (!this.matchesTipePegawai.length) {
            return;
            }
            this.selectedItemTipePegawai = this.matchesTipePegawai[this.selectedTipePegawai];
            this.visibleTipePegawai = false;
            this.kodeTipePegawai = this.selectedItemTipePegawai.value
            this.queryTipePegawai = this.selectedItemTipePegawai.text
            if (this.shouldReset) {
            this.queryTipePegawai = '';
            this.selectedTipePegawai = 0;
            }
        },
        upTipePegawai() {
            if (this.selectedTipePegawai == 0) {
            return;
            }
            this.selectedTipePegawai -= 1;
            this.scrollToItemTipePegawai();
        },
        downTipePegawai() {
            if (this.selectedTipePegawai >= this.matchesTipePegawai.length - 1) {
            return;
            }
            this.selectedTipePegawai += 1;
            this.scrollToItemTipePegawai();
        },
        scrollToItemTipePegawai() {
            this.$refs.optionsList.scrollTop = this.selectedTipePegawai * this.itemHeight;
        },

        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.hariKerjaKalender.toLowerCase() < b.hariKerjaKalender.toLowerCase()) {
                        return -1
                    }
                    if (a.hariKerjaKalender.toLowerCase() > b.hariKerjaKalender.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.hariKerjaPegawai.toLowerCase() < b.hariKerjaPegawai.toLowerCase()) {
                        return -1
                    }
                    if (a.hariKerjaPegawai.toLowerCase() > b.hariKerjaPegawai.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.jks.toLowerCase() < b.jks.toLowerCase()) {
                        return -1
                    }
                    if (a.jks.toLowerCase() > b.jks.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.jkp.toLowerCase() < b.jkp.toLowerCase()) {
                        return -1
                    }
                    if (a.jkp.toLowerCase() > b.jkp.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.wfh.toLowerCase() < b.wfh.toLowerCase()) {
                        return -1
                    }
                    if (a.wfh.toLowerCase() > b.wfh.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.wfo.toLowerCase() < b.wfo.toLowerCase()) {
                        return -1
                    }
                    if (a.wfo.toLowerCase() > b.wfo.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 7) {
                function compare(a,b) {
                    if (a.dinas.toLowerCase() < b.dinas.toLowerCase()) {
                        return -1
                    }
                    if (a.dinas.toLowerCase() > b.dinas.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 8) {
                function compare(a,b) {
                    if (a.ijin.toLowerCase() < b.ijin.toLowerCase()) {
                        return -1
                    }
                    if (a.ijin.toLowerCase() > b.ijin.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 9) {
                function compare(a,b) {
                    if (a.mangkir.toLowerCase() < b.mangkir.toLowerCase()) {
                        return -1
                    }
                    if (a.mangkir.toLowerCase() > b.mangkir.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }else if(value == 10) {
                function compare(a,b) {
                    if (a.nso.toLowerCase() < b.nso.toLowerCase()) {
                        return -1
                    }
                    if (a.nso.toLowerCase() > b.nso.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 11) {
                function compare(a,b) {
                    if (a.telat.toLowerCase() < b.telat.toLowerCase()) {
                        return -1
                    }
                    if (a.telat.toLowerCase() > b.telat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 12) {
                function compare(a,b) {
                    if (a.acuanCuti.toLowerCase() < b.acuanCuti.toLowerCase()) {
                        return -1
                    }
                    if (a.acuanCuti.toLowerCase() > b.acuanCuti.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getDownload() {
            this.$store.state.loadingScreen = true
            let pegawai = ''
            if(this.queryPegawai != '') {
                pegawai = this.queryPegawai.split(" - ")[1]
            } else {
                pegawai = ''
            }
            let lvl = ''
            if(this.queryUnit != '') {
                lvl = this.idUnits
            } else {
                lvl = ''
            }
            let bulan = this.date.monthIndex
            let typePegawai = this.kodeTipePegawai
            let limit = this.totalRow
            let nama = pegawai
            let page = 1
            let payload = {
                bulan: bulan,
                lvl: lvl,
                limit: limit,
                nama: nama,
                pageIn: page,
                tahun: this.date.year,
                typePegawai: typePegawai
            }
            DataApi.post("absensi/backoffice/kehadiran_lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let downloads = response.data.data
                    let fileName = 'Absensi Kehadiran' + bulan + '-' + this.date.year
                    let data = [
                        {
                            sheet: fileName,
                            columns: [
                                { label: 'Nama', value: 'nama'  },
                                { label: 'NIP', value: 'nik' },
                                { label: 'Bulan', value: 'bulan'},
                                { label: 'Tahun', value: 'tahun'},
                                { label: 'Hari Kerja Seharusnya', value: 'hariKerjaKalender'},
                                { label: 'Hari Kerja Pegawai', value: 'hariKerjaPegawai'},
                                { label: 'Jam Kerja Seharusnya', value: 'jks'},
                                { label: 'Jam Kerja Pegawai', value: 'jkp'},
                                { label: 'Total WFH', value: 'wfh' },
                                { label: 'Total WFO', value: 'wfo' },
                                { label: 'Dinas', value: 'dinas'},
                                { label: 'Total Leave Request', value: 'leaveRequest'},
                                { label: 'Cuti', value: 'cuti'},
                                { label: 'Ijin', value: 'ijin'},
                                { label: 'Sakit', value: 'sakit'},
                                { label: 'Mangkir', value: 'mangkir'},
                                { label: 'NSI', value: 'nsi'},
                                { label: 'NSO', value: 'nso'},
                                { label: 'Terlambat', value: 'telat'},
                                { label: 'Pulang Cepat', value: 'cepet'},
                                { label: 'Mangkir per Tahun', value: 'acuanCuti'},
                            ],
                            content: downloads
                        }
                    ]
                    let settings = {
                        fileName: fileName
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let pegawai = ''
            if(this.queryPegawai != '') {
                pegawai = this.queryPegawai.split(" - ")[1]
            } else {
                pegawai = ''
            }
            let lvl = ''
            if(this.queryUnit != '') {
                lvl = this.idUnits
            } else {
                lvl = ''
            }
            let bulan = this.date.monthIndex
            let typePegawai = this.kodeTipePegawai
            let limit = this.size
            let nama = pegawai
            let page = this.page
            let payload = {
                bulan: bulan,
                lvl: lvl,
                limit: limit,
                nama: nama,
                pageIn: page,
                tahun: this.date.year,
                typePegawai: typePegawai
            }
            DataApi.post("absensi/backoffice/kehadiran_lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.errorMessage = response.message
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalRow = 0
                    this.totalPage = 1
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        setDate() {
            let month = this.tanggal.getMonth() + 1
            let year = this.tanggal.getFullYear()
            this.date.monthIndex = month
            this.date.year = year
        },
        findData() {
            this.getData()
        },
        reload() {
            this.queryPegawai = ''
            this.queryUnit = ''
            this.idUnits = ''
            this.queryTipePegawai = ''
            this.kodeTipePegawai = ''
            this.getDataPegawai()
            this.getDataUnit()
            this.getDataTipePegawai()
            this.setDate()
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        showDate(date) {
            this.date = date
        },


        // detail
        getDetail(value) {
            this.datasTemporary = value
            this.$store.state.loadingScreen = true
            let payload = {
                bulan: this.date.monthIndex,
                idPegawai: this.datas[value].idPegawai,
                tahun: this.date.year
            }
            let sendParam = []
            DataApi.post('absensi/backoffice/kehadiran_detail', payload)
            .then( res=> {
                let response = res.data
                if(response.success == true) {
                    sendParam = [
                        {
                            data: response.data,
                            flag: true,
                            message: response.message,
                            nama: this.datas[value].nama,
                            nik: this.datas[value].nik
                        }
                    ]
                } else {
                    sendParam = [
                        {
                            data: [],
                            flag: false,
                            message: response.message,
                            nama: '',
                            nik: ''
                        }
                    ]
                }
                this.getDetailMangkir(sendParam)
            })
        },
        getDetailMangkir(param) {
            let payload = {
                bulan: this.date.monthIndex,
                idPegawai: this.datas[this.datasTemporary].idPegawai,
                tahun: this.date.year
            }
            let sendParam = []
            DataApi.post('absensi/backoffice/acuan_cuti_detail', payload)
            .then( res=> {
                let response = res.data
                if(response.success == true) {
                    sendParam = [
                        {
                            data: response.data.waktu,
                            lastUpdate: response.data.lastUpdate,
                            periode: response.data.periode,
                            tanggalAktif: response.data.tanggalAktif
                        }
                    ]
                } else {
                    sendParam = [
                        {
                            data: [],
                            lastUpdate: '-',
                            periode: '-',
                            tanggalAktif: ''
                        }
                    ]
                }
                this.$store.state.loadingScreen = false
                this.$refs.dialog.openModal([ ...param, ...sendParam ])
            })
        },
        getDownloadDetail() {
            this.$store.state.loadingScreen = true
            let payload = {
                bulan: this.date.monthIndex,
                idPegawai: this.datas[this.datasTemporary].idPegawai,
                tahun: this.date.year
            }
            DataApi.post('absensi/backoffice/kehadiran_detail', payload)
            .then( res=> {
                let response = res.data
                if(response.success == true) {
                    let downloads = response.data
                    let rawFileName = 'Kehadiran-' + this.datas[this.datasTemporary].nik + '(' + this.date.monthIndex + '-' + this.date.year + ')'

// Bersihkan karakter ilegal dan batasi hingga 31 karakter
let safeSheetName = rawFileName.replace(/[:\\/?*\[\]]/g, '').substring(0, 31)
                    // let fileName = 'Kehadiran-' + this.datas[this.datasTemporary].nik + '(' + this.date.monthIndex + '-' + this.date.year + ')'
                    let data = [
                        {
                            sheet: safeSheetName,
                            columns: [
                                { label: 'Hari, Tanggal', value: 'hariTanggal'  },
                                { label: 'Jadwal', value: 'jadwal' },
                                { label: 'Jam Masuk', value: 'jamMasuk' },
                                { label: 'Jam Keluar', value: 'jamKeluar' },
                                { label: 'Jam Kerja Seharusnya', value: 'jks' },
                                { label: 'Jam Kerja Pegawai', value: 'jkp' },
                                { label: 'Status', value: 'status'},
                                { label: 'Keterangan', value: 'keterangan'}
                            ],
                            content: downloads
                        }
                    ]
                    let settings = {
                        fileName: rawFileName 
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        },
        getDownloadMangkir() {
            this.$store.state.loadingScreen = true
            let payload = {
                bulan: this.date.monthIndex,
                idPegawai: this.datas[this.datasTemporary].idPegawai,
                tahun: this.date.year
            }
            DataApi.post('absensi/backoffice/acuan_cuti_detail', payload)
            .then( res=> {
                let response = res.data
                if(response.success == true) {
                    let downloads = response.data.waktu
                    let fileName = 'Mangkir-' + this.datas[this.datasTemporary].nik + '(' + this.date.monthIndex + '-' + this.date.year + ')'
                    let data = [
                        {
                            sheet: fileName,
                            columns: [
                                { label: 'Hari, Tanggal', value: 'hariTanggal'  },
                                { label: 'Keterangan', value: 'keterangan'}
                            ],
                            content: downloads
                        }
                    ]
                    let settings = {
                        fileName: fileName
                    }
                    xlsx(data, settings)
                }
                this.$store.state.loadingScreen = false
            })
        },
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataPegawai()
        this.getDataUnit()
        this.getDataTipePegawai()
        this.setDate()
    }
}
</script>
<style scoped>
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.nowraps {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-title {
    font-size: 14px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.btn-search {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    float: right;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(360deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 24px;
    padding-right: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 12px;
    padding-right: 24px;
    padding-left: 24px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
::v-deep .month-picker__container {
    z-index: 5 !important;
    width: 250px;
}
::v-deep .month-picker__year button {
    width: 50px;
    height: 48px;
}
::v-deep .month-picker-input {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .875rem;
    font-weight: 400;
    line-height: 1.5;
    background-clip: padding-box;
    border: 1px solid;
    color: #768192;
    border-color: #d8dbe0;
    background-color: #f9fafc;
    border-radius: .25rem;
}
::v-deep .month-picker-input-container {
    width: 100%;
    min-width: none;
}
</style>